import { PatientPayersActions } from './constant';

const {
  CREATE_PATIENT_PAYER_REQUEST,
  CREATE_PATIENT_PAYER_RESET,
  GET_ALL_PATIENT_PAYER_REQUEST,
  GET_ALL_PATIENT_PAYER_RESET,
  UPDATE_PATIENT_PAYER_REQUEST,
  UPDATE_PATIENT_PAYER_RESET,
  VALIDATE_MDS_PAYER_REQUEST,
  VALIDATE_MDS_PAYER_RESET,
  GET_PAYER_OPTIONS_REQUEST,
  GET_PAYER_OPTIONS_RESET,
  GET_PAYER_DATE_RANGES_REQUEST,
  GET_PAYER_DATE_RANGES_RESET,
  GET_PAYER_HISTORY_REQUEST,
  GET_PAYER_HISTORY_RESET,
} = PatientPayersActions;

export const createPatientPayerAction = (payload: object) => {
  return {
    type: CREATE_PATIENT_PAYER_REQUEST,
    payload,
  };
};

export const resetCreatePatientPayerAction = () => {
  return {
    type: CREATE_PATIENT_PAYER_RESET,
  };
};

export const updatePatientPayerAction = (payload: object) => {
  return {
    type: UPDATE_PATIENT_PAYER_REQUEST,
    payload,
  };
};

export const resetUpdatePatientPayerAction = () => {
  return {
    type: UPDATE_PATIENT_PAYER_RESET,
  };
};

export const getAllPatientPayersAction = (payload: object) => {
  return {
    type: GET_ALL_PATIENT_PAYER_REQUEST,
    payload,
  };
};

export const resetGetAllPatientPayersAction = () => {
  return {
    type: GET_ALL_PATIENT_PAYER_RESET,
  };
};

// Validate payer edit against MDS assessment ARDs
export const validateMdsPayerAction = (payload: object) => {
  return {
    type: VALIDATE_MDS_PAYER_REQUEST,
    payload,
  };
};

export const resetValidateMdsPayerAction = () => {
  return {
    type: VALIDATE_MDS_PAYER_RESET,
  };
};

export const getPayerOptionsAction = (payload: object) => {
  return {
    type: GET_PAYER_OPTIONS_REQUEST,
    payload,
  };
};

export const resetGetPayerOptionsAction = () => {
  return {
    type: GET_PAYER_OPTIONS_RESET,
  };
};

export const getPayerDateRangesAction = (payload: object) => {
  return {
    type: GET_PAYER_DATE_RANGES_REQUEST,
    payload,
  };
};

export const resetGetPayerDateRangesAction = () => {
  return {
    type: GET_PAYER_DATE_RANGES_RESET,
  };
};

export const getPayerHistoryAction = (payload: object) => {
  return {
    type: GET_PAYER_HISTORY_REQUEST,
    payload,
  };
};

export const resetGetPayerHistoryAction = () => {
  return {
    type: GET_PAYER_HISTORY_RESET,
  };
};
